// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-container {
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-lg);
  min-height: 140px;
  position: relative;
}

.editor-content {
  min-height: 140px;
  position: relative;
  max-height: 360px;
  overflow-y: auto;
  outline: none;
  font-size: 16px;
  color: var(--text-primary);
  caret-color: #667eea;
}

.editor-content h1 {
  display: block;
  font-size: 2.5rem;
  font-weight: 700;
  margin: 20px 0;
}

.editor-content h2 {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  margin: 18px 0;
}

.editor-content h3 {
  display: block;
  font-size: 1.75rem;
  font-weight: 700;
  margin: 16px 0;
}

.editor-content h4 {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 14px 0;
}

.editor-content h5 {
  display: block;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 12px 0;
}

.editor-content h6 {
  display: block;
  font-size: 1rem;
  font-weight: 700;
  margin: 10px 0;
}

.editor-content p {
  display: block;
  margin-bottom: 10px;
}

.editor-content span {
  display: inline;
}

.editor-content b,
.editor-content strong {
  font-weight: bold;
}

.editor-content i,
.editor-content em {
  font-style: italic;
}

.editor-content u {
  text-decoration: underline;
}

.editor-content small {
  font-size: 80%;
}

.editor-content mark {
  background: yellow;
  color: #000;
  padding: 2px 4px;
}

.editor-content del {
  text-decoration: line-through;
}

.editor-content ins {
  text-decoration: underline;
}

.editor-content sub {
  vertical-align: sub;
  font-size: smaller;
}

.editor-content sup {
  vertical-align: super;
  font-size: smaller;
}

/* Placeholder styling */
.editor-content:empty::before {
  content: attr(data-placeholder);
  color: var(--text-muted);
  pointer-events: none;
  position: absolute;
  opacity: 0.6;
}

.editor-content a {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.editor-content audio {
  width: 100%;
}

.editor-content a:hover {
  color: #764ba2;
  /* cursor: pointer; */
}

.editor-content ul {
  list-style: disc;
  padding-left: 40px;
  margin: 16px 0;
  color: var(--text-secondary);
}

.editor-content ol {
  list-style: decimal;
  padding-left: 40px;
  margin: 16px 0;
  color: var(--text-secondary);
}

.editor-content li {
  margin: 6px 0;
  display: list-item;
}

.editor-content img {
  width: auto;
  height: auto;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  transition:
    transform var(--transition-base),
    box-shadow var(--transition-base);
  cursor: pointer;
  display: block;
}

/* Floating resizer box */
.image-resizer {
  position: absolute;
  border: 2px solid #2563eb;
  box-sizing: border-box;
  pointer-events: none;
  z-index: 9999;
}

/* Handles */
.image-resizer .handle {
  position: absolute;
  width: 10px;
  height: 10px;
  background: #2563eb;
  border: 2px solid white;
  border-radius: 50%;
  box-sizing: border-box;
  pointer-events: all;
}

/* Positions */
.handle.nw {
  top: -6px;
  left: -6px;
  cursor: nwse-resize;
}

.handle.n {
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  cursor: ns-resize;
}

.handle.ne {
  top: -6px;
  right: -6px;
  cursor: nesw-resize;
}

.handle.e {
  top: 50%;
  right: -6px;
  transform: translateY(-50%);
  cursor: ew-resize;
}

.handle.se {
  bottom: -6px;
  right: -6px;
  cursor: nwse-resize;
}

.handle.s {
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  cursor: ns-resize;
}

.handle.sw {
  bottom: -6px;
  left: -6px;
  cursor: nesw-resize;
}

.handle.w {
  top: 50%;
  left: -6px;
  transform: translateY(-50%);
  cursor: ew-resize;
}

.top-left {
  top: -6px;
  left: -6px;
  cursor: nwse-resize;
}

.top {
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  cursor: ns-resize;
}

.top-right {
  top: -6px;
  right: -6px;
  cursor: nesw-resize;
}

.right {
  top: 50%;
  right: -6px;
  transform: translateY(-50%);
  cursor: ew-resize;
}

.bottom-right {
  bottom: -6px;
  right: -6px;
  cursor: nwse-resize;
}

.bottom {
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  cursor: ns-resize;
}

.bottom-left {
  bottom: -6px;
  left: -6px;
  cursor: nesw-resize;
}

.left {
  top: 50%;
  left: -6px;
  transform: translateY(-50%);
  cursor: ew-resize;
}

.editor-content .video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  margin: 1rem 0;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  background: var(--bg-tertiary);
}

.editor-content .video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: var(--radius-md);
}

.editor-content blockquote {
  padding-left: 16px;
  margin: 20px 0;
  border-left: 4px solid #667eea;
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
  color: var(--text-secondary);
  font-style: italic;
}

.editor-content q {
  quotes: auto;
}

.editor-content code {
  padding: 2px 4px;
  background: var(--bg-tertiary);
  border-radius: var(--radius-sm);
  font-family: monospace;
  color: #f093fb;
}

.editor-content figure {
  margin: 20px 0;
}

.editor-content figcaption {
  margin-top: 8px;
  font-size: 14px;
}

.editor-content details {
  margin: 16px 0;
}

.editor-content summary {
  cursor: pointer;
  font-weight: 600;
}

.editor-content pre {
  margin: 20px 0;
  background: var(--bg-tertiary);
  border-radius: var(--radius-md);
  overflow-x: auto;
  border: 1px solid var(--border-color);
}

.editor-content pre code {
  padding: 0;
  background: transparent;
  border-radius: 0;
  color: var(--text-secondary);
}

.editor-content kbd {
  border: 1px solid #ccc;
  padding: 2px 6px;
}

.editor-content hr {
  margin: 24px 0;
  border: none;
  height: 2px;
  background: black;
}

.editor-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.editor-content table th,
.editor-content table td {
  border: 1px solid #ddd;
  padding: 12px;
}

.editor-content table th {
  font-weight: bold;
  color: var(--text-primary);
}

.editor-content table td {
  background: var(--bg-secondary);
  color: var(--text-secondary);
}

.editor-content table tr:hover td {
  background: var(--bg-tertiary);
}

/* Selection styling */
.editor-content ::selection {
  background: rgba(102, 126, 234, 0.3);
  color: var(--text-primary);
}

/* Smooth scrolling */
.editor-content {
  scroll-behavior: smooth;
}

.image-skeleton {
  width: 100%;
  height: 250px;
  background: linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 50%, #e5e7eb 100%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
  border-radius: 8px;
  margin: 8px 0;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}

@keyframes contentFadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .editor-content {
    padding: 1.5rem;
    font-size: 15px;
    max-height: 500px;
  }

  .editor-content h1 {
    font-size: 2rem;
  }

  .editor-content h2 {
    font-size: 1.75rem;
  }

  .editor-content h3 {
    font-size: 1.5rem;
  }

  .editor-content table {
    display: block;
    overflow-x: auto;
  }
}

@media (max-width: 480px) {
  .editor-content {
    padding: 1rem;
    font-size: 14px;
    min-height: 400px;
    max-height: 450px;
  }

  .editor-content h1 {
    font-size: 1.75rem;
  }

  .editor-content h2 {
    font-size: 1.5rem;
  }

  .editor-content h3 {
    font-size: 1.25rem;
  }

  .editor-content ul,
  .editor-content ol {
    padding-left: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/EditorContent.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B;;qCAEmC;EACnC,eAAe;EACf,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,oDAAoD;EACpD,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yEAAyE;EACzE,0BAA0B;EAC1B,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;AACF","sourcesContent":[".editor-container {\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: var(--shadow-lg);\n  min-height: 140px;\n  position: relative;\n}\n\n.editor-content {\n  min-height: 140px;\n  position: relative;\n  max-height: 360px;\n  overflow-y: auto;\n  outline: none;\n  font-size: 16px;\n  color: var(--text-primary);\n  caret-color: #667eea;\n}\n\n.editor-content h1 {\n  display: block;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 20px 0;\n}\n\n.editor-content h2 {\n  display: block;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 18px 0;\n}\n\n.editor-content h3 {\n  display: block;\n  font-size: 1.75rem;\n  font-weight: 700;\n  margin: 16px 0;\n}\n\n.editor-content h4 {\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 14px 0;\n}\n\n.editor-content h5 {\n  display: block;\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 12px 0;\n}\n\n.editor-content h6 {\n  display: block;\n  font-size: 1rem;\n  font-weight: 700;\n  margin: 10px 0;\n}\n\n.editor-content p {\n  display: block;\n  margin-bottom: 10px;\n}\n\n.editor-content span {\n  display: inline;\n}\n\n.editor-content b,\n.editor-content strong {\n  font-weight: bold;\n}\n\n.editor-content i,\n.editor-content em {\n  font-style: italic;\n}\n\n.editor-content u {\n  text-decoration: underline;\n}\n\n.editor-content small {\n  font-size: 80%;\n}\n\n.editor-content mark {\n  background: yellow;\n  color: #000;\n  padding: 2px 4px;\n}\n\n.editor-content del {\n  text-decoration: line-through;\n}\n\n.editor-content ins {\n  text-decoration: underline;\n}\n\n.editor-content sub {\n  vertical-align: sub;\n  font-size: smaller;\n}\n\n.editor-content sup {\n  vertical-align: super;\n  font-size: smaller;\n}\n\n/* Placeholder styling */\n.editor-content:empty::before {\n  content: attr(data-placeholder);\n  color: var(--text-muted);\n  pointer-events: none;\n  position: absolute;\n  opacity: 0.6;\n}\n\n.editor-content a {\n  color: blue;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.editor-content audio {\n  width: 100%;\n}\n\n.editor-content a:hover {\n  color: #764ba2;\n  /* cursor: pointer; */\n}\n\n.editor-content ul {\n  list-style: disc;\n  padding-left: 40px;\n  margin: 16px 0;\n  color: var(--text-secondary);\n}\n\n.editor-content ol {\n  list-style: decimal;\n  padding-left: 40px;\n  margin: 16px 0;\n  color: var(--text-secondary);\n}\n\n.editor-content li {\n  margin: 6px 0;\n  display: list-item;\n}\n\n.editor-content img {\n  width: auto;\n  height: auto;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-md);\n  transition:\n    transform var(--transition-base),\n    box-shadow var(--transition-base);\n  cursor: pointer;\n  display: block;\n}\n\n/* Floating resizer box */\n.image-resizer {\n  position: absolute;\n  border: 2px solid #2563eb;\n  box-sizing: border-box;\n  pointer-events: none;\n  z-index: 9999;\n}\n\n/* Handles */\n.image-resizer .handle {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background: #2563eb;\n  border: 2px solid white;\n  border-radius: 50%;\n  box-sizing: border-box;\n  pointer-events: all;\n}\n\n/* Positions */\n.handle.nw {\n  top: -6px;\n  left: -6px;\n  cursor: nwse-resize;\n}\n\n.handle.n {\n  top: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: ns-resize;\n}\n\n.handle.ne {\n  top: -6px;\n  right: -6px;\n  cursor: nesw-resize;\n}\n\n.handle.e {\n  top: 50%;\n  right: -6px;\n  transform: translateY(-50%);\n  cursor: ew-resize;\n}\n\n.handle.se {\n  bottom: -6px;\n  right: -6px;\n  cursor: nwse-resize;\n}\n\n.handle.s {\n  bottom: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: ns-resize;\n}\n\n.handle.sw {\n  bottom: -6px;\n  left: -6px;\n  cursor: nesw-resize;\n}\n\n.handle.w {\n  top: 50%;\n  left: -6px;\n  transform: translateY(-50%);\n  cursor: ew-resize;\n}\n\n.top-left {\n  top: -6px;\n  left: -6px;\n  cursor: nwse-resize;\n}\n\n.top {\n  top: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: ns-resize;\n}\n\n.top-right {\n  top: -6px;\n  right: -6px;\n  cursor: nesw-resize;\n}\n\n.right {\n  top: 50%;\n  right: -6px;\n  transform: translateY(-50%);\n  cursor: ew-resize;\n}\n\n.bottom-right {\n  bottom: -6px;\n  right: -6px;\n  cursor: nwse-resize;\n}\n\n.bottom {\n  bottom: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: ns-resize;\n}\n\n.bottom-left {\n  bottom: -6px;\n  left: -6px;\n  cursor: nesw-resize;\n}\n\n.left {\n  top: 50%;\n  left: -6px;\n  transform: translateY(-50%);\n  cursor: ew-resize;\n}\n\n.editor-content .video-container {\n  position: relative;\n  padding-bottom: 56.25%;\n  height: 0;\n  overflow: hidden;\n  margin: 1rem 0;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-md);\n  background: var(--bg-tertiary);\n}\n\n.editor-content .video-container iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: var(--radius-md);\n}\n\n.editor-content blockquote {\n  padding-left: 16px;\n  margin: 20px 0;\n  border-left: 4px solid #667eea;\n  border-radius: 0 var(--radius-md) var(--radius-md) 0;\n  color: var(--text-secondary);\n  font-style: italic;\n}\n\n.editor-content q {\n  quotes: auto;\n}\n\n.editor-content code {\n  padding: 2px 4px;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-sm);\n  font-family: monospace;\n  color: #f093fb;\n}\n\n.editor-content figure {\n  margin: 20px 0;\n}\n\n.editor-content figcaption {\n  margin-top: 8px;\n  font-size: 14px;\n}\n\n.editor-content details {\n  margin: 16px 0;\n}\n\n.editor-content summary {\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.editor-content pre {\n  margin: 20px 0;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-md);\n  overflow-x: auto;\n  border: 1px solid var(--border-color);\n}\n\n.editor-content pre code {\n  padding: 0;\n  background: transparent;\n  border-radius: 0;\n  color: var(--text-secondary);\n}\n\n.editor-content kbd {\n  border: 1px solid #ccc;\n  padding: 2px 6px;\n}\n\n.editor-content hr {\n  margin: 24px 0;\n  border: none;\n  height: 2px;\n  background: black;\n}\n\n.editor-content table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 20px 0;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n}\n\n.editor-content table th,\n.editor-content table td {\n  border: 1px solid #ddd;\n  padding: 12px;\n}\n\n.editor-content table th {\n  font-weight: bold;\n  color: var(--text-primary);\n}\n\n.editor-content table td {\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n}\n\n.editor-content table tr:hover td {\n  background: var(--bg-tertiary);\n}\n\n/* Selection styling */\n.editor-content ::selection {\n  background: rgba(102, 126, 234, 0.3);\n  color: var(--text-primary);\n}\n\n/* Smooth scrolling */\n.editor-content {\n  scroll-behavior: smooth;\n}\n\n.image-skeleton {\n  width: 100%;\n  height: 250px;\n  background: linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 50%, #e5e7eb 100%);\n  background-size: 200% 100%;\n  animation: skeleton-shimmer 1.5s infinite;\n  border-radius: 8px;\n  margin: 8px 0;\n}\n\n@keyframes skeleton-shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n@keyframes contentFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(5px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .editor-content {\n    padding: 1.5rem;\n    font-size: 15px;\n    max-height: 500px;\n  }\n\n  .editor-content h1 {\n    font-size: 2rem;\n  }\n\n  .editor-content h2 {\n    font-size: 1.75rem;\n  }\n\n  .editor-content h3 {\n    font-size: 1.5rem;\n  }\n\n  .editor-content table {\n    display: block;\n    overflow-x: auto;\n  }\n}\n\n@media (max-width: 480px) {\n  .editor-content {\n    padding: 1rem;\n    font-size: 14px;\n    min-height: 400px;\n    max-height: 450px;\n  }\n\n  .editor-content h1 {\n    font-size: 1.75rem;\n  }\n\n  .editor-content h2 {\n    font-size: 1.5rem;\n  }\n\n  .editor-content h3 {\n    font-size: 1.25rem;\n  }\n\n  .editor-content ul,\n  .editor-content ol {\n    padding-left: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
